var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tilteBox"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.titleName))]),_c('img',{attrs:{"src":require("@/assets/img/border-bottom.png"),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }